"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactTippy = require("react-tippy");
var PriceInfoCard = function PriceInfoCard(_ref) {
  var price = _ref.price,
    handleOnClick = _ref.handleOnClick,
    image = _ref.image,
    tooltip = _ref.tooltip,
    descriptionText = _ref.descriptionText,
    rating = _ref.rating,
    bedrooms = _ref.bedrooms,
    sleepsSofa = _ref.sleepsSofa;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "price-info-card mb40",
    onClick: handleOnClick,
    tabIndex: "0",
    role: "button",
    "aria-pressed": "false"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "price-info-card--top mt10 aspect-4-3",
    style: {
      backgroundImage: "url(".concat(image, ")")
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "overlay bottom"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "wrapper"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "wrapper-top"
  }, rating && /*#__PURE__*/_react["default"].createElement("p", {
    className: "bold white-font xs-font rating",
    style: {
      "float": 'right',
      backgroundColor: rating.color
    }
  }, rating.name)))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "price-info-card--bottom"
  }, descriptionText && /*#__PURE__*/_react["default"].createElement("div", {
    className: "gray-font"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "mr05"
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "material-icons m-font"
  }, "group")), /*#__PURE__*/_react["default"].createElement("span", null, descriptionText)), tooltip ? /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "tooltip__wrapper"
  }, /*#__PURE__*/_react["default"].createElement(_reactTippy.Tooltip, {
    html: tooltip,
    position: "top",
    trigger: "mouseenter click",
    theme: "light",
    arrow: true,
    style: {
      background: 'none'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "bold"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "lg-font"
  }, price), /*#__PURE__*/_react["default"].createElement("span", null, "pp"), "\xA0", /*#__PURE__*/_react["default"].createElement("i", {
    className: "material-icons s-font"
  }, "info"))))) : /*#__PURE__*/_react["default"].createElement("div", {
    className: "bold"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "lg-font"
  }, price), /*#__PURE__*/_react["default"].createElement("span", null, "pp")), bedrooms && /*#__PURE__*/_react["default"].createElement("div", {
    className: "gray-font mr10",
    style: {
      display: 'inline-block'
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "mr05"
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "material-icons s-font"
  }, "airline_seat_individual_suite")), /*#__PURE__*/_react["default"].createElement("span", null, bedrooms)), sleepsSofa && /*#__PURE__*/_react["default"].createElement("div", {
    className: "gray-font",
    style: {
      display: 'inline-block'
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "mr05"
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "material-icons s-font"
  }, "weekend")), /*#__PURE__*/_react["default"].createElement("span", null, "1"))));
};
PriceInfoCard.propTypes = {
  descriptionText: _propTypes["default"].string,
  image: _propTypes["default"].string,
  price: _propTypes["default"].string,
  rating: _propTypes["default"].string,
  handleOnClick: _propTypes["default"].func,
  tooltip: _propTypes["default"].object,
  bedrooms: _propTypes["default"].number,
  sleepsSofa: _propTypes["default"].bool
};
var _default = exports["default"] = PriceInfoCard;